function moveElementsInFooter() {
  const footerElm = document.querySelector("#footer");
  const qualityContainer = document.querySelector(".quality-container");
  const footerBottom = document.querySelector(".footer-bottom");
  // Pokud není footer nebo quality-container nalezen, funkce skončí
  if (!footerElm || !qualityContainer) return;

  // Přesunutí quality-container před footer
  footerElm.parentNode.insertBefore(qualityContainer, footerElm);
  footerElm.insertAdjacentElement("afterend", footerBottom);
}
